<template>
    <div class="content d-flex flex-column">
        <Accueil ref="home" />
        <Programme ref="programme" />
        <Intervenants ref="intervenants" />
        <PermisTronconneuse ref="permis-tronconneuse" />
        <InfosAcces ref="acces" />
        <GoogleMap />
    </div>
</template>

<script>
import Accueil from "./_Accueil.vue";
import Programme from "./_Programme.vue";
import Intervenants from "./_Intervenants.vue";
import InfosAcces from "./_InfosAcces.vue";
import GoogleMap from "./_GoogleMap.vue";
import PermisTronconneuse from "./_PermisTronconneuse.vue";

export default {
    components: {
        Accueil,
        Programme,
        Intervenants,
        InfosAcces,
        GoogleMap,
        PermisTronconneuse,
    },
};
</script>
